





































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class About extends Vue {

  public readonly authorDiscord = 'Disquse#1111';

  public readonly publicRepoUrl = 'https://github.com/disquse/pubgserversping';
}
